import { Link } from 'react-router-dom';
import { Award, Building2, ClipboardCheck, Trophy } from 'lucide-react';
import { useAuth } from '@/lib/auth';

const PILLARS = [
  {
    icon: ClipboardCheck,
    title: 'Self-assessments',
    body: 'Find out where you stand on phishing, passwords, privacy and device safety, with advice for each weak spot.',
  },
  {
    icon: Trophy,
    title: 'Contests',
    body: 'Poster and short-film contests inside a college, across a country or around the world.',
  },
  {
    icon: Award,
    title: 'Shareable proof',
    body: 'Verifiable certificates and Open Badges you can add to LinkedIn in one click.',
  },
  {
    icon: Building2,
    title: 'For organizations',
    body: 'Universities and enterprises enrol members by domain or code and see readiness across every college and team.',
  },
];

export function LandingPage() {
  const { user } = useAuth();
  return (
    <div className="space-y-16">
      <section className="relative pt-6 text-center">
        <div
          className="bg-halo-turmeric pointer-events-none absolute inset-x-0 -top-10 mx-auto h-64 max-w-2xl"
          aria-hidden
        />
        <p className="relative text-sm font-medium text-primary">Practice. Compete. Prove it.</p>
        <h1 className="relative mt-3 text-4xl font-semibold tracking-tight sm:text-5xl">
          Are you cyber ready?
        </h1>
        <p className="relative mx-auto mt-4 max-w-xl text-lg text-muted-foreground">
          Nirvik Ready helps students, professionals and whole organizations build and prove
          everyday cyber readiness.
        </p>
        <div className="relative mt-8 flex justify-center gap-3">
          <Link
            to={user ? '/home' : '/signin'}
            className="rounded-[var(--radius)] bg-primary px-5 py-2.5 text-sm font-medium text-primary-foreground hover:opacity-90"
          >
            {user ? 'Go to your dashboard' : 'Get started'}
          </Link>
        </div>
      </section>

      <section className="grid gap-4 sm:grid-cols-2">
        {PILLARS.map(({ icon: Icon, title, body }) => (
          <div key={title} className="rounded-xl border border-border bg-card p-5">
            <Icon className="size-5 text-primary" aria-hidden />
            <h2 className="mt-3 font-semibold">{title}</h2>
            <p className="mt-1 text-sm text-muted-foreground">{body}</p>
          </div>
        ))}
      </section>
    </div>
  );
}
